module.exports = __webpack_public_path__ + "img/web3icon5.ed9aad2e.png";